import { EnumBase } from 'hay-core-react';
class TemplateExibicaoresultadoEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.monitoramentotemplate.exibicaoresultado.table',
        'main.monitoramentotemplate.exibicaoresultado.cards',
      ],
      'main.monitoramentotemplate.exibicaoresultado.table'
    );
  }
}

export default new TemplateExibicaoresultadoEnum();
